import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../js/charSequenceJs.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from './stringJs.mjs';
import {
  toString1n9qg6fb0b5i8 as toString_0,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { toString30pk9tzaqopn as toString_1 } from '../Library.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from '../collections/AbstractList.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../CharSequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringBuilderClass;
function StringBuilder() {
  if (StringBuilderClass === VOID) {
    class $ {
      constructor(content) {
        return new.target.new_kotlin_text_StringBuilder_7at1nh_k$(content);
      }
      static new_kotlin_text_StringBuilder_7at1nh_k$(content) {
        var $this = createThis(this);
        $this.string_1 = content;
        return $this;
      }
      static new_kotlin_text_StringBuilder_wcb3z_k$(capacity) {
        return this.new_kotlin_text_StringBuilder_u46mrb_k$();
      }
      static new_kotlin_text_StringBuilder_u46mrb_k$() {
        return this.new_kotlin_text_StringBuilder_7at1nh_k$('');
      }
      get_length_g42xv3_k$() {
        // Inline function 'kotlin.js.asDynamic' call
        return this.string_1.length;
      }
      get_kdzpvg_k$(index) {
        // Inline function 'kotlin.text.getOrElse' call
        var this_0 = this.string_1;
        var tmp;
        if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
          tmp = charSequenceGet(this_0, index);
        } else {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('index: ' + index + ', length: ' + this.get_length_g42xv3_k$() + '}');
        }
        return tmp;
      }
      subSequence_hm5hnj_k$(startIndex, endIndex) {
        return substring(this.string_1, startIndex, endIndex);
      }
      append_58al37_k$(value) {
        this.string_1 = this.string_1 + toString_0(value);
        return this;
      }
      append_jgojdo_k$(value) {
        this.string_1 = this.string_1 + toString_1(value);
        return this;
      }
      append_xdc1zw_k$(value, startIndex, endIndex) {
        return this.appendRange_arc5oa_k$(value == null ? 'null' : value, startIndex, endIndex);
      }
      append_t8pm91_k$(value) {
        this.string_1 = this.string_1 + toString_1(value);
        return this;
      }
      append_g4kq45_k$(value) {
        this.string_1 = this.string_1 + value;
        return this;
      }
      append_uppzia_k$(value) {
        return this.append_22ad7x_k$(value.toString());
      }
      append_cu3spi_k$(value) {
        return this.append_22ad7x_k$(value.toString());
      }
      append_22ad7x_k$(value) {
        var tmp = this;
        var tmp_0 = this.string_1;
        tmp.string_1 = tmp_0 + (value == null ? 'null' : value);
        return this;
      }
      insert_i6yv0i_k$(index, value) {
        Companion_instance.checkPositionIndex_w4k0on_k$(index, this.get_length_g42xv3_k$());
        this.string_1 = substring(this.string_1, 0, index) + toString_0(value) + substring_0(this.string_1, index);
        return this;
      }
      setLength_oy0ork_k$(newLength) {
        if (newLength < 0) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Negative new length: ' + newLength + '.');
        }
        if (newLength <= this.get_length_g42xv3_k$()) {
          this.string_1 = substring(this.string_1, 0, newLength);
        } else {
          var inductionVariable = this.get_length_g42xv3_k$();
          if (inductionVariable < newLength)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.string_1 = this.string_1 + toString_0(_Char___init__impl__6a9atx(0));
            }
             while (inductionVariable < newLength);
        }
      }
      toString() {
        return this.string_1;
      }
      clear_1keqml_k$() {
        this.string_1 = '';
        return this;
      }
      deleteAt_mq1vvq_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this.get_length_g42xv3_k$());
        this.string_1 = substring(this.string_1, 0, index) + substring_0(this.string_1, index + 1 | 0);
        return this;
      }
      appendRange_arc5oa_k$(value, startIndex, endIndex) {
        var stringCsq = toString(value);
        Companion_instance.checkBoundsIndexes_tsopv1_k$(startIndex, endIndex, stringCsq.length);
        this.string_1 = this.string_1 + substring(stringCsq, startIndex, endIndex);
        return this;
      }
    }
    initMetadataForClass($, 'StringBuilder', $.new_kotlin_text_StringBuilder_u46mrb_k$, VOID, [CharSequence()]);
    StringBuilderClass = $;
  }
  return StringBuilderClass;
}
//region block: exports
export {
  StringBuilder as StringBuildermazzzhj6kkai,
};
//endregion

//# sourceMappingURL=StringBuilderJs.mjs.map
